import React from "react";
import styles from './LocationFlightCompany.module.scss'
import {ITicketDetailsWithTerms} from 'gui/components/editors/flightEditor/components/ticketDetailsForm';
import LogoSquare
  from 'gui/components/listPage/components/ad/components/genericImageSquare/components/logoSquare';
import {flightCompanyToLogoUrl} from 'gui/components/listPage/components/ad/components/airlineImageSquare';

export interface ILocationFlightCompanyProps {
  ticketDetails: ITicketDetailsWithTerms;
  flip?: boolean;
}


const LocationFlightCompany = ({flip, ticketDetails}: ILocationFlightCompanyProps) => {
  const flightCompany = flip ? ticketDetails.destinationFlightCompany : ticketDetails.originFlightCompany;
  return (
    <div
      className={styles.LocationFlightCompany}
    >
      <LogoSquare
        logoSrc={flightCompanyToLogoUrl(flightCompany)}
        logoTitle={flightCompany.name}
      />
      <span className={styles.airlineName}>{flightCompany.name}</span>
    </div>
  )
};

LocationFlightCompany.defaultProps = {
  fromDestination: false,
  style: {},
};

export default LocationFlightCompany;
